import { render } from "./EmployeeReviews.vue?vue&type=template&id=3319031a&scoped=true&ts=true"
import script from "./EmployeeReviews.vue?vue&type=script&lang=ts"
export * from "./EmployeeReviews.vue?vue&type=script&lang=ts"

import "./EmployeeReviews.vue?vue&type=style&index=0&id=3319031a&lang=scss&scoped=true"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3319031a"]])

export default __exports__